import React from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import _get from 'lodash/get';

import Masks from '../../Global/Inputs/Masks';
import ShipmentUtils from '../../../utils/Shipment';

import Button from '@material-ui/core/Button';

import combineStyles from '../../../utils/combineStyles';
import TypographyStyles from '../../../styles/typography';
import LayoutStyles from '../../../styles/layout';
import ButtonStyles from '../../../styles/button';
import SpacingStyles from '../../../styles/helpers/spacing';

import SummaryStyles from './__styles__/Summary.styles';

export const Main = ({ t, classes, shipment }) => (
  <section className={classes.wrapper}>
    <h1 className={classnames(classes.headline7, classes.summaryTitle)}>
      {t('Shipment Summary')}
    </h1>
    <div className={classes.summaryDetails}>
      <div>
        <div className={classes.summaryDetailsSection}>
          <p className={classes.subtitle2}>{t('Pickup')}</p>
          <p className={classes.body2Light}>
            {_get(shipment, 'pickup.locationName', null)}
          </p>
          <p className={classes.body2Light}>
            {_get(shipment, 'pickup.locationAddress.address1', null)}
          </p>
          <p className={classes.body2Light}>
            {ShipmentUtils.formatAddress(
              _get(shipment, 'pickup.locationAddress', {})
            )}
          </p>
        </div>
        <div className={classes.summaryDetailsSection}>
          <p className={classes.subtitle2}>{t('Shipment Number')}</p>
          <p className={classes.body2Light}>{shipment.id}</p>
        </div>
        <div className={classes.summaryDetailsSection}>
          <p className={classes.subtitle2}>{t('BOL Number')}</p>
          <p className={classes.body2Light}>{shipment.bolNumber}</p>
        </div>
      </div>
      <div>
        <div className={classes.summaryDetailsSection}>
          <p className={classes.subtitle2}>{t('Delivery')}</p>
          <p className={classes.body2Light}>
            {_get(shipment, 'delivery.locationName', null)}
          </p>
          <p className={classes.body2Light}>
            {_get(shipment, 'delivery.locationAddress.address1', null)}
          </p>
          <p className={classes.body2Light}>
            {ShipmentUtils.formatAddress(
              _get(shipment, 'delivery.locationAddress', {})
            )}
          </p>
        </div>
        <div className={classes.summaryDetailsSection}>
          <p className={classes.subtitle2}>{t('Delivery Contact')}</p>
          <p className={classes.body2Light}>
            {`${_get(shipment, 'delivery.contactInfo.firstName', null)} ${_get(
              shipment,
              'delivery.contactInfo.lastName',
              null
            )} `}
          </p>
          <Masks.phone
            value={_get(shipment, 'delivery.contactInfo.phone', null)}
            displayType="text"
            className={classes.body2Light}
          />
          <p className={classes.body2Light}>
            {_get(shipment, 'delivery.contactInfo.email', null)}
          </p>
        </div>
      </div>
    </div>
    <Button
      variant="outlined"
      color="primary"
      className={classnames(classes.outlinedButton, classes.noMarginBottom)}
      classes={{ label: classes.buttonLabel }}
      component={Link}
      to={`/shipments/${shipment.id}`}
    >
      {t('View Shipment Details')}
    </Button>
  </section>
);

Main.propTypes = {
  shipment: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    bolNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    pickup: PropTypes.shape({
      locationName: PropTypes.string.isRequired,
      locationAddress: PropTypes.shape({
        address1: PropTypes.string.isRequired,
        city: PropTypes.string.isRequired,
        state: PropTypes.string.isRequired,
        postalCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
          .isRequired,
        country: PropTypes.string.isRequired
      }).isRequired
    }).isRequired,
    delivery: PropTypes.shape({
      locationName: PropTypes.string.isRequired,
      locationAddress: PropTypes.shape({
        address1: PropTypes.string.isRequired,
        city: PropTypes.string.isRequired,
        state: PropTypes.string.isRequired,
        postalCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
          .isRequired,
        country: PropTypes.string.isRequired
      }).isRequired,
      contactInfo: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        phone: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
          .isRequired,
        email: PropTypes.string.isRequired
      }).isRequired
    }).isRequired
  }).isRequired
};

const MainWithTranslation = withNamespaces()(Main);
export default withStyles(
  combineStyles(
    TypographyStyles,
    LayoutStyles,
    SpacingStyles,
    ButtonStyles,
    SummaryStyles
  )
)(MainWithTranslation);
